import { FormText } from '../../shared/messages/form-text';

import { Button, Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { auth } from '../../lib/firebaseAuth';
import { USERS_COLLECTION } from '../../shared/variables/collections';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectUserData, setUserData } from '../../store/slices/userSlice';
import { showNotification } from '../../shared/utils/notifications';
import { NotificationText } from '../../shared/messages/notification-text';

// eslint-disable-next-line no-unused-vars
type PhoneAction = (phone: string) => void | Promise<void>;

export default function AddPhoneNumber({
  visibility,
  close,
  success,
  onSubmit,
}: {
  visibility: boolean;
  close: () => void;
  success?: PhoneAction;
  onSubmit?: PhoneAction;
}) {
  const userData = useAppSelector(selectUserData);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const addPhone = async (values: any) => {
    if (loading) return;
    setLoading(true);
    try {
      const { phone } = values;
      if (onSubmit) {
        await onSubmit(phone);
      } else {
        const uid = auth.currentUser?.uid;
        if (!uid) throw new Error('Telefon kaydetmek için tekrar giriş yapın.');
        // Firestore yalnız kaydederken yüklenir; modalı barındıran sayfaların ilk paketine girmez.
        const [{ doc, updateDoc, firestore }, { getUserByUid }] = await Promise.all([
          import('../../lib/firestoreActions'),
          import('../../lib/firestoreClient'),
        ]);
        const profile = userData?.uid === uid ? userData : (await getUserByUid(uid))[0];
        if (!profile?.id) throw new Error('Kullanıcı profili yüklenemedi. Lütfen tekrar deneyin.');
        await updateDoc(doc(firestore, USERS_COLLECTION, profile.id), { null_tel: phone });
        dispatch(setUserData({ ...profile, null_tel: phone }));
        await success?.(phone);
        showNotification('success', NotificationText.ADD_PHONE_SUCCESS);
      }
      form.resetFields();
    } catch (e: any) {
      showNotification('error', e?.message || NotificationText.ADD_PHONE_ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t('modals.addPhone.title')}
      visible={visibility}
      footer={null}
      onCancel={close}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
    >
      <div className="mb-xl">{t('modals.addPhone.description')}</div>
      <Form form={form} name="telefon-ekle" layout="vertical" onFinish={addPhone}>
        <Form.Item
          label={t('modals.addPhone.label')}
          name="phone"
          rules={[
            { required: true, message: FormText.REQUIRED },
            { len: 11, message: FormText.PHONE_LEN },
            { pattern: /^\d+$/, message: FormText.PHONE_NUMBER },
          ]}
        >
          <Input type="tel" autoComplete="tel" inputMode="tel" disabled={loading} />
        </Form.Item>
        <div className="text-right">
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('modals.addPhone.submit')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

AddPhoneNumber.defaultProps = { success: undefined, onSubmit: undefined };
